import { createFileRoute, redirect } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { z } from "zod";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ensureQueryData } from "@/hooks/use-graphql";
import { ChangeOnlinePaymentStatusForm } from "@/components/payment/forms/change-online-payment-status-form";

import type { JSX } from "react";

const ChangePaymentStatusPageQuery = graphql(/* GraphQL */ `
  query GetOnlinePaymentByGuid($guid: uuid!) {
    onlinePayment: expensum_online_payment(where: { guid: { _eq: $guid } }) {
      guid
    }
  }
`);

const ChangeOnlinePaymentStatusPageSearchParams = z.object({
  action: z.string().optional(),
});

const ChangeOnlinePaymentStatusPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton align="start" icon={Left} />
        <HeaderTitle title="Alterar status" align="center" />
      </HeaderRoot>
      <Page>
        <ChangeOnlinePaymentStatusForm />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/$guid/change-online-payment-status",
)({
  component: ChangeOnlinePaymentStatusPage,
  validateSearch: ChangeOnlinePaymentStatusPageSearchParams,
  beforeLoad: async (opts) => {
    try {
      const guid = opts.params.guid;
      const data = await ensureQueryData(opts.context, ChangePaymentStatusPageQuery, {
        guid,
      });

      if (data.onlinePayment.length === 0) {
        throw new Error("Payment not found!");
      }
    } catch (_e) {
      redirect({
        to: "/settings/payments/patient-payments",
        throw: true,
      });
    }
    return {};
  },
});
